const DEPLOY_ENV = process.env.MUJI_APP_DEPLOY_ENV || 'staging';
const API_BASE = (function () {
    switch (DEPLOY_ENV) {
        case 'dev':
        case 'staging':
            return {
                zhuge: 'http://zhuge-api.dasouche.net',
                getAuthz: 'http://sso.dasouche-inc.net',
                interfaceExperienceUrl: 'http://open.dasouche-inc.net/index.html#/proxy',
            };
        case 'prepub':
            return {
                zhuge: 'http://zhuge-api.prepub.souche.com',
                getAuthz: 'http://sso.souche-inc.com',
                interfaceExperienceUrl: 'http://experience.open.souche.com/index.html#/proxy',
            };
        case 'prod':
            return {
                zhuge: 'https://zhuge-api.souche.com',
                getAuthz: 'https://sso.souche-inc.com',
                interfaceExperienceUrl: 'https://experience-open.souche.com/index.html#/proxy',
            };
    }
})();
export default API_BASE;
